import { lazy }  from "react";
import ReactDOM from "react-dom";
import { Provider } from 'react-redux'
import { useCheckAccess } from "./hooks/useCheckAccess";
import { store } from './store.js'
import Loadable from "./General/Loadable.jsx";
import { setEntry } from "./EntryHelpers/setEntry.js";
import { useRootCssVars } from "./hooks/useRootCssVars.js";

const PageOverview = Loadable(lazy(() => import("./PageOverview/index.jsx")))
const PageOverviewAccess = Loadable(lazy(() => import("./PageOverviewAccess/PageOverviewAccess.jsx")))

const AccessWrapperOverview = ({isWebApp})  => {
    const useAccesTheme = useCheckAccess() 
    useRootCssVars(useAccesTheme)

    if(useAccesTheme) {
        return <PageOverviewAccess withMainSlider={false} /> 
    } else {
        return <PageOverview isWebApp={isWebApp}/>
    }
}

const elem = document.querySelector("#overview-page")

if(elem)  {
    const [isWebApp, isMobile] = setEntry()

    ReactDOM.render(
        <Provider store={store}>
            <AccessWrapperOverview isWebApp={isWebApp}/>
        </Provider>
    , elem)
}
